import { CheckoutFooter } from './CheckoutFooter'
import { MainFooter } from './MainFooter'

type Props = {
  isCheckout?: boolean
}

const Footer = ({ isCheckout = false }: Props) => (
  <footer>{!isCheckout ? <MainFooter /> : <CheckoutFooter />}</footer>
)

export default Footer
